<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<BackButton @back-click="handleBackButton"
						class="arrow-btn arrow-btn-back--grey top" />
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form class="w-100" @submit.prevent>
			<div class="rounded-container">
				<div class="row">
					<div class="col">
						<h2 class="h4 has-tooltip-static">
							{{ microcopy.increaseBorrowingLabel }}
							<Tooltip :content="microcopy.increaseBorrowingTooltip" />
						</h2>
					</div>
				</div>
				<div class="row">
					<div class="col d-flex flex-column flex-md-row rounded-container__btn-col rounded-container__btn-col-x2--small">
						<fieldset>
							<legend class="visually-hidden"><span>Please select an option</span></legend>
							<RadioInputComponent v-for="option in options"
												 :key="option"
												 :options="option"
												 :selected-option="selected"
												 @selected="(payload) => {
								postIncreaseBorrowing(payload);
								selected = payload;
							}">
								<template v-slot:tooltip>
									<Tooltip :content="microcopy.depositInputTooltip" />
								</template>
							</RadioInputComponent>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-6 d-flex flex-column flex-md-row pe-md-0">

						<div v-if="selected.text === 'Yes' && selected.selected">
							<h2 class="h4 mb-4 mt-custom-1 has-tooltip-static">
								{{ microcopy?.howMuchToBorrowDropdownLabel }}
								<Tooltip :content="microcopy.howMuchToBorrowTooltip" />
							</h2>
							<DropdownField :options="mappedMortgageIncrease"
										   :error-text="microcopy?.howMuchToBorrowDropdownError"
										   @selected="(payload) => {
									postBorrowingAmount(payload);
									selectedBorrowingOption = payload;
								}" />
						</div>
					</div>
				</div>
				<div class="row btm-btn-group__contained">
					<div class="col text-center d-flex flex-column align-items-start">
						<GenericButton :label-text="progressionText"
									   :button-disabled="buttonDisabled"
									   @button-click="handleClick" />
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
	import GenericButton from '@/shared/components/GenericButton.vue';
	import BackButton from '@/shared/components/BackButton.vue';
	import DropdownField from '@/shared/components/DropdownField.vue';
	import Tooltip from '@/shared/components/Tooltip.vue';

	import router from '../router/index.js';

	import { mapStores, mapActions, mapState } from 'pinia';
	import { useMortgageStore } from '../stores/mortgageStore.js';

	export default {
		components: {
			RadioInputComponent,
			GenericButton,
			BackButton,
			DropdownField,
			Tooltip
		},
		data() {
			return {
				microcopy: window.mortgageRequestMicrocopy.remortgagingNeeds,
				options: {
					yes: {
						text: 'Yes',
					},
					no: {
						text: 'No',
					},
				},
				progressionText: 'Continue',
				selected: {},
				selectedBorrowingOption: '',
				mappedMortgageIncrease: []
			};
		},
		computed: {
			...mapStores(useMortgageStore),
			...mapState(useMortgageStore, ['increaseBorrowing', 'howMuchBorrow']),
			buttonDisabled() {
				if (this.selected.text === 'Yes') {
					return this.selectedBorrowingOption === '';
				}
				else if (this.selected.text === 'No' && this.selected.selected) {
					return false;
				}
				return true;
			},
			nextPage() {
				return 'your-details';
			},
		},
		methods: {
			...mapActions(useMortgageStore, ['postBorrowingAmount', 'postIncreaseBorrowing']),
			handleClick() {
				scrollTo({ top: 0, behavior: 'smooth' });
				router.push(this.nextPage);
			},
			handleBackButton() {
				router.back();
			},
		},
		mounted() {
			if (this.increaseBorrowing) {
				this.selected = this.increaseBorrowing;
			}

			document.title = this.microcopy?.metaTitle
			this.mappedMortgageIncrease = this.microcopy?.howMuchToBorrowDropdownOptions.map(element => element['text'].replace(/&#xA3;/g, "£").replace(/&#x27;/g, "'"));

		},
	};

</script>
